export default __webpack_public_path__ + "static/media/friend-active-color-icon.44debeb9.svg";